export const SOCIETE_CHOOSE_DOUBLE_REWARDS_TAKEOVER_ID = 'societeChooseDoubleRewardsTakeover'
export const CHOOSE_DOUBLE_REWARDS_SLUG = 'choose-double-rewards'
export const CHOOSE_DOUBLE_REWARDS_OFFERS_ANCHOR = 'campaign-offers'
export const CHOOSE_DOUBLE_REWARDS_IMAGE_ID = 'choose-your-double-rewards-campaign'
export const CHOOSE_DOUBLE_REWARDS_CAMPAIGN_TAG = 'choose_your_double_rewards_nov_2026'
